<template>
  <div id="bottomRight" class="content-box-item">
    <div class="bottom-top">
      <div class="icon-desc">
        <el-image :src="require('@/assets/icons/icon-5.png')" fit="fit"/>
        <span class="icon-desc-txt">营销链接跳转</span>
      </div>
      <div ><el-image :src="require('@/assets/icons/button-1.png')" fit="fit" style="margin-top: 15px"/></div>
    </div>
    <div class="bottom-bottom">
      <div class="icon-desc">
        <el-image :src="require('@/assets/icons/icon-6.png')" fit="fit"/>
        <span class="icon-desc-txt">商城业绩统计</span>
      </div>
      <el-image :src="require('@/assets/icons/button-1.png')" fit="fit" style="margin-top: 15px" />
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import globaldata from "../../../utils/globaldata";
export default {
  data() {
    return {
      marketWebUrl: process.env.MARKET_WEB_URL,
      userId: globaldata.getAdminStore().id,
    }
  },
  //
  props: {
    cdata: {
      type: Array,
      default: () => ([])
    },
  },
  watch: {
    cdata: {
      handler (newData) {

      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  methods: {
    openMarket(){
      let mytoken = getToken();
      window.open(this.marketWebUrl+'?token='+mytoken+'&userId='+this.userId, '_blank');
    }

  }
}
</script>

<style lang="scss" scoped>
#bottomRight {
  width: calc(100% - 15px);
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  .bottom-top{
    width: 100%;
    height: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #ecf0f1;
  }
  .bottom-bottom{
    width: 100%;
    height: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    border-top: 1px solid #ECF0F1;
  }
  .icon-desc{
    width: 40%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .icon-desc-txt{
    font-size: 18px;
    line-height: 45px;
    text-align: center;
    color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/data/bottom/bottomRight.vue